import { DatePipe } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ServiceViewModel } from 'src/app/business/service-entity/view-model/service-view-model';
import { ArticleStatusPipe } from 'src/app/common/pipes/article/articlestatus-pipe';

@Component({
  selector: 'itl-integratedcare-service',
  templateUrl: './integratedcare-service.component.html',
  styleUrls: ['./integratedcare-service.component.scss'],
  providers: [DatePipe, ArticleStatusPipe],
  standalone: false,
})
export class IntegratedCareServiceComponent implements OnInit, AfterViewInit {
  @Input()
  service: ServiceViewModel;
  @Input()
  icon = '';
  @Input()
  iconColor: string;
  @Input()
  hasCheckbox = false;
  @Input()
  isChecked = false;
  @Input()
  isWizardPage = true;
  @Input() actions: TemplateRef<any>;
  @Output()
  checked = new EventEmitter();

  isSmallScreen = false;
  hasActions = false;

  constructor(
    private _breakpointObserver: BreakpointObserver,
    private _changeDetectorRef: ChangeDetectorRef,
    private _viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this._breakpointObserver.observe('(max-width: 700px)').subscribe(result => {
      this.isSmallScreen = result.matches;
      this._changeDetectorRef.markForCheck();
    });
  }

  ngAfterViewInit(): void {
    if (this.actions) {
      const actionsView = this._viewContainerRef.createEmbeddedView(this.actions);
      this.hasActions = actionsView.rootNodes.length > 0;
      actionsView.destroy();
    }
    this._changeDetectorRef.detectChanges();
  }

  public toggleCheckbox() {
    if (this.hasCheckbox) {
      this.checked.emit();
    }
  }
}
